import { render, staticRenderFns } from "./DynamicAttributeType.vue?vue&type=template&id=68ac50c5&"
import script from "./DynamicAttributeType.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports